import React, { forwardRef } from 'react'
import { styled, TableRow } from '@mui/material'

export const Root = styled(forwardRef(({ margin, padding, ...props }, ref) => <TableRow {...props} ref={ref} />))`
  &.MuiTableRow-root {
    font-family: ${props => props.theme.typography.fontFamily};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: 100%;
  }

  &.MuiTableRow-root[data-selected='true'] {
    background-color: ${props => props.theme.palette.blue[95]};
  }
`
